import { getAPI, postAPI } from "../../api/api";
import axios from 'axios';
import { REACT_APP_RECRUITER , REACT_APP_CANDIDATEFILTER , REACT_APP_CUSTOMER  } from "../../utils/common";
import { AnyARecord } from "dns";


export async function getFilteredCandidates(body: any, value?: string){
    const Details = postAPI(`https://search-ellow-test-domain-idre2gbljizarsx72j32ce5lre.ap-south-1.es.amazonaws.com/stage-resources/_search?${value ? `q=${value}` : ''}`, body)
    return Details
}

export async function getAllocatedto() {
    const Details = getAPI( REACT_APP_RECRUITER + "/list")
    return Details
}

export async function getProviderResources(){
  const Details = getAPI( REACT_APP_CUSTOMER + '/getProviderResources')
  return Details
}

export async function getRecruiterResources(){
  const Details = getAPI( REACT_APP_RECRUITER + '/list')
  return Details
}

export async function getCandidates(tabName: string,  pageSize: number, pageNumber: number, searchValue: string, filters?: any, sort?:any){

    let sortfilter={
       
    };
    if(sort)
    {
      if(sort.length!=0)
      {
         sortfilter={
              
                sortBy:sort[0].field,
                sortOrder:sort[0].dir
            
        };
      }
    }
    if (filters) { 
        
      let merge:any={};
      if (tabName === 'myDraft') {
      var ne:any= {...filters, loginId:localStorage.getItem('loginId')};
      
   ne={filters:ne};

   if( Object.keys(sortfilter).length===0)
   {
       merge=ne;
   }
   else
   {
    
    merge={...ne,sort:sortfilter};
   } 
      }  
      else
      {
        
      
           
        

        if( Object.keys(sortfilter).length===0)

        {
          if(filters.filters)
          {
            merge=filters;
          }
          else
          {
            merge={filters}; 
          }
        
        }
        else
        {
            if(filters.filters)
            {
              merge=filters;
            }
            else
            {
              merge={filters}; 
            }
          
            merge={...merge,sort:sortfilter};
        }
      }
    
       

    const Details = postAPI( REACT_APP_CANDIDATEFILTER +  `/candidate-filter?page=${pageNumber}&size=${pageSize}&tab=${tabName}&search=${searchValue}`, merge)
    return Details
    }
    else {
        let body = {}
        
        if( Object.keys(sortfilter).length===0)
        {
            body = {
                filters: {
                    'loginId': localStorage.getItem('loginId')
                }
               
              
            }
        }
        else
        {
        body = {
            filters: {
                'loginId': localStorage.getItem('loginId')
            },
            sort:sortfilter
          
        }
    }
    const Details = postAPI( REACT_APP_CANDIDATEFILTER +  `/candidate-filter?page=${pageNumber}&size=${pageSize}&tab=${tabName}&search=${searchValue}`, body)
    return Details
    }
    
}
